export default __webpack_public_path__ + "static/media/manageuser-icon.ad9e3905.svg";